import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCountriesLoading = (isLoading) => {
  return {
    type: actionTypes.SET_COUNTRIES_LOADING,
    payload: isLoading
  }
}
